<template>
  <AppNavbar :show-logout="sesionActiva" @logout="cerrarSesion" />
  <LoginForm v-if="!sesionActiva" @success="onLoginSuccess" />
  <HomeForm v-else />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import AppNavbar from './components/AppNavbar.vue';
import HomeForm from './components/HomeForm.vue';
import LoginForm from './components/LoginForm.vue';
import {
  STORAGE_ACCESS_TOKEN,
  applyStoredAuthToAxios,
  clearAuthSession,
} from './Api/auth';

const sesionActiva = ref(false);

function sincronizarSesion() {
  sesionActiva.value = Boolean(
    sessionStorage.getItem(STORAGE_ACCESS_TOKEN),
  );
  applyStoredAuthToAxios();
}

function onLoginSuccess() {
  sincronizarSesion();
}

function cerrarSesion() {
  clearAuthSession();
  sesionActiva.value = false;
}

onMounted(() => {
  sincronizarSesion();
});
</script>

<style>
@import "./Fonts/font/stylesheet.css";

body {
  padding-top: 6rem;
}

#app {
  font-family: "Scandia";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0;
}
</style>
